<template>
    <div
        class="relative gap-6 justify-center h-auto my-8"
        :class="containerless ? 'col-span-full grid grid-cols-subgrid' : 'container grid grid-cols-12 w-full'"
        ref="elementRef"
    >
        <div
            v-if="content"
            class="md:col-start-2 col-span-full md:col-span-5 ease-linear duration-75 flex flex-col items-center justify-center translate-y-0 md:[translate:0px_var(--ty)] gap-y-4"
            :style="{ '--ty': `${50 * normalized}px` }"
        >
            <ResponsiveMedia
                :media-id="content?.['media-left']"
                css-class="self-end w-full rounded-sm"
                autoplay
                muted
                playing
                loop
                preload="metadata"
            />
            <div class="self-start text-caption text-dark-blue/75 ">{{get_localized_value(content?.['text-left'])}}</div>
        </div>
        <div
            class="col-span-full md:col-span-5 flex flex-col items-center justify-center translate-y-0 md:[translate:0px_var(--ty)] gap-y-4"
            :style="{ '--ty': `${50 * normalized * -1}px` }"
        >
            <ResponsiveMedia
                :media-id="content?.['media-right']"
                css-class="self-start w-full rounded-sm"
                autoplay
                muted
                preload="metadata"
                loop
                playing
            />
            <div class="self-start text-caption text-dark-blue/75 ">{{get_localized_value(content?.['text-right'])}}</div>
        </div>

<!--        <div class="absolute top-0 left-0 z-100 bg-white">{{ distance }}, {{ normalized }}</div>-->
    </div>
</template>

<script lang="ts" setup>
import ResponsiveMedia from '~/components/ResponsiveMedia.vue'

type DuoParallaxContent = {
    'media-left'?: string
    'text-left'?: unknown
    'media-right'?: string
    'text-right'?: unknown
}

const elementRef = ref(null)
const { normalized } = useDistanceFromCenter(elementRef)
const { get_value: get_localized_value } = useLocalizedValue()

const props = defineProps({
    content: {
        type: Object as PropType<DuoParallaxContent>
    },
    containerless: {
        type: Boolean,
        default: false
    }
})

</script>
